module.exports = __webpack_public_path__ + "static/media/map-marker-vaccination-place.467aa539.svg";